<div class="modal-header">
  <h4 class="modal-title" i18n>Personal information</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
</div>
<div class="modal-body">
  <form [formGroup]="form">
    <div class="row g-3">
      <div class="col-12">
        <label class="form-label" i18n>First name</label>
        <input class="form-control" formControlName="first_name" autocomplete="given-name"
          [class.is-invalid]="form.get('first_name')?.invalid && form.get('first_name')?.touched">
      </div>
      <div class="col-12">
        <label class="form-label" i18n>Last name</label>
        <input class="form-control" formControlName="last_name" autocomplete="family-name"
          [class.is-invalid]="form.get('last_name')?.invalid && form.get('last_name')?.touched">
      </div>
      <div class="col-12">
        <label class="form-label" i18n>Email</label>
        <input class="form-control" required formControlName="email" autocomplete="email"
          [class.is-invalid]="form.get('email')?.invalid && form.get('email')?.touched">
      </div>
      <div class="col-12">
        <label class="form-label" i18n>Mobile phone</label>
        <input class="form-control" formControlName="mobile_phone" autocomplete="tel"
          [class.is-invalid]="form.get('mobile_phone')?.invalid">
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" [disabled]="!this.form.valid" (click)="save()" i18n>Save</button>
  <button type="button" class="btn btn-secondary" (click)="activeModal.close()" i18n>Close</button>
</div>